import React from 'react';
import { IIconProps } from './utils';

export const CloudFailed = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 20 20" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.17188 15C2.79116 15 1.67188 13.8807 1.67188 12.5C1.67188 11.1894 2.68034 10.1144 3.9636 10.0086C4.07827 9.99909 4.17143 9.90645 4.17614 9.79148C4.28546 7.12676 6.4803 5 9.17188 5C11.3379 5 13.1823 6.37736 13.8769 8.30403C13.9165 8.41383 14.0355 8.47442 14.1483 8.4445C14.4218 8.37198 14.709 8.33333 15.0052 8.33333C16.8462 8.33333 18.3385 9.82572 18.3385 11.6667C18.3385 13.5076 16.8462 15 15.0052 15H4.17188Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M9.16667 10.8327L10.8333 12.4993M9.16667 10.8327L10.8333 9.16602M9.16667 10.8327L7.5 9.16602M9.16667 10.8327L7.5 12.4993"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
  </svg>
);
